import React from "react";
import "./empty_state.ui.scss";

interface IEmptyState {
  message: string;
  icon?: React.ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState = (props: IEmptyState) => {
  const { message, icon, actionLabel, onAction } = props;

  return (
    <div className="empty_state">
      {icon && <div className="empty_state_icon">{icon}</div>}
      <p className="empty_state_message">{message}</p>
      {actionLabel && onAction && (
        <button type="button" className="empty_state_action" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
